export const PAGE_CONTEXTS = {
  SERIES: 'Series',
  MODULE: 'Module',
  LEARNER: 'Learner',
  REVIEWER: 'Reviewer',
  MANAGER: 'Manager',
  GROUP: 'Group',
};
